import { Modal, ModalBody } from "reactstrap";
import welcomeBanner from "../../../assets/img/photos/welcome3.jpg";


function WelcomeModal({ isOpen, dismissModal, takeAction }) {
    return <Modal isOpen={isOpen} toggle={dismissModal} className="medium full" >
        <img src={welcomeBanner} alt="Welcome" style={{ height: 300, width: '100%', objectFit: 'cover' }} />
        <div className="modalHeader">
            <button className="contained" onClick={dismissModal} style={{ position: 'absolute', right: 15, top: 15, padding: 7 }}><i className='las la-times white'></i></button>
        </div>
        <ModalBody className="modalBody">
            <div className="p-50 text-c pt-30">
                <h1>You've made it!</h1>
                <h1 className="mb-20">Welcome to simple.events</h1>
                <p className="mb-40" style={{ maxWidth: 500 }}>
                    Get started by exploring your new workspace by yourself or take a quick guided tour.
                </p>
                <div className="flex jcc gap20">
                    <button className="outline minWidth" onClick={dismissModal}>I'll explore</button>
                    <button className="prim minWidth" onClick={takeAction}>Take the tour</button>

                </div>
            </div>
        </ModalBody>
    </Modal>
}

export default WelcomeModal;